import { useFetcher } from "~/hooks/useFetcher";

const { VITE_RWB_API } = import.meta.env;

export interface ExternalBucket {
  bucket_name: string;
  description: string;
}

/**
 * Fetches the list of external S3 buckets the current user has access to.
 * The backend handles filtering the buckets based on the user's permissions.
 */
const useExternalBuckets = () => {
  return useFetcher<ExternalBucket[]>(`${VITE_RWB_API}/file-browser/external-buckets`);
};

export default useExternalBuckets;
